// Shorter aliases for check and default value
const is = Array.isArray;
const U = undefined;

// Use for the most simple getters of business logic objects fields

export const oneFieldAmount = (object) => object && object.amount;
export const oneFieldFinalPrice = (object) => object && object.finalPrice;
export const oneFieldPrice = (object) => object && object.price;
export const oneFieldTransfers = (object) => object && object.transfers;
export const oneFieldUseDeposit = (object) => object && object.use_deposit;
export const oneFieldUsedAmount = (object) => object && object.used_amount;

// Use for arrays of objects that have the business logic field

export const allFieldsAmount = (array) => (is(array) ? array.map(oneFieldAmount) : U);
export const allFieldsFinalPrice = (array) => (is(array) ? array.map(oneFieldFinalPrice) : U);
export const allFieldsPrice = (array) => (is(array) ? array.map(oneFieldPrice) : U);
export const allFieldsTransfers = (array) => (is(array) ? array.map(oneFieldTransfers) : U);
export const allFieldsUseDeposit = (array) => (is(array) ? array.map(oneFieldUseDeposit) : U);
export const allFieldsUsedAmount = (array) => (is(array) ? array.map(oneFieldUsedAmount) : U);
